<!-- <template>
  <div class="login_bg">
    <img src="../../../static/index/logo.png" style="margin:80px 60px 0 100px" />
    <div class="login_top">
      <div class="login_box">
        <div class="login-logo">
          <h2>格瑞德智慧供应链平台</h2>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="forruleFormm" label-width="0 "
          style="    margin: 60px 30px 30px 30px;" size="large">
          <el-form-item prop="user">
            <el-input v-model="ruleForm.user" prefix-icon="el-icon-user" clearable placeholder="用户名">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="ruleForm.password" prefix-icon="el-icon-lock" clearable show-password
              placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%;margin-top:40px" :loading="islogin" round @click="login">登
              录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="login-footer">©2021 山东格瑞德集团有限公司版权所有</div>
  </div>
</template> -->
<script>
import Cookie from "js-cookie";
import { mapGetters, mapMutations } from "vuex";
import { cartCount } from "@/api/cart.js";
import { getVerify, loginWeb, registerID, getUserInfo } from "@/api/login.js";
import { async } from "q";
import { getNextPage,setNextPage } from '@/axios/cookies.js'
export default {
  name: "jumpLogin",
    beforeRouteEnter (to, from, next) {
    next(vm => {
      const whiteList = [
        '/productDetail', // 商品明细
        '/indexpage/productlist', // 商品列表

      ]
      if (whiteList.indexOf(from.path) !== -1){
        console.log(from, 'from')
        setNextPage(from.fullPath)
      }
    })
  },
  data() {
    return {
      fromPath:"",
      ruleForm: {
        user: "",
        password: "",
      },
      regForm: {
        tel: "",
        code: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      regRules: {
        // pass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      islogin: false,
      show: "login",
      activeName: "pwdLogin",
      registerVisible: true,
      forgotVisible: true,
      loading: false,
      loading1: false,
      loading2: false,
      phoneNumber: null,
      phoneNumber1: null,
      phoneNumber2: null,
      authCode: null,
      authCode1: null,
      authCode2: null,
      pwd: "",
      pwd1: "",
      pwd2: "",
      pwdAgain: "",
      pwdAgain1: "",
      showTime: false,
      showTime1: false,
      showTime2: false,
      time: 60,
      time1: 60,
      time2: 60,
      timer: null,
      timer1: null,
      timer2: null,
      read: false,
      relus: /^1[13456789]\d{9}$/,
    };
  },
  computed: {
    ...mapGetters([
      "loginVisible", // 登录注册弹窗开关
    ]),
  },
  created(){
    this.login()
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO", // 修改用户信息
      setCartNum: "SET_CARTNUM", // 修改购物车商品数量
    }),
    // 登录
    async login() {
      const queryObj = this.$router.history.current.query;
      let seconds = queryObj.expires_in;
      let expires = new Date(new Date() * 1 + seconds * 1000);
      Cookie.set("Yshop_token", queryObj.token);
      Cookie.set("expires", expires);
      await this.getUserInfo();
    },

    // 获取购物车商品数量
    async getCartNum() {
      var res = await cartCount();
      if (res.status === 200) {
        this.setCartNum(res.data.count);
      } else {
        this.$message.warning(res.msg);
      }
    },

    // 获取用户信息
    async getUserInfo() {
      var res = await getUserInfo();
      if (res.status === 200) {
        this.$store.commit("setLoginVisible", false);
        // this.$store.commit('setUser', res.data)
        // this.$store.commit('userInfo', res.data)
        // 登录信息存入内存中
        sessionStorage.setItem('SET_USER_INFO', JSON.stringify(res.data));
        this.$store.commit(
          "SET_USERINFO",
          res.data,
          new Date().getTime() + 3000
        );
        if(getNextPage()){
          this.$router.push(getNextPage())
        }else{
          this.$router.push("/indexpage/index")
        }
      }
    }
  },
};
</script>
<style scoped>
.login_bg {
  background: #fff;
  /* position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px; */
}




.login-logo {
  background: #fff;
  text-align: center;
  /* margin-bottom: 30px; */
}

.login-logo .logo {
  height: 70px;
  vertical-align: bottom;
}

.login-logo h2 {
  font-size: 24px;
  margin-top: 20px;
  color: #40485b;
}

.login-title {
  margin-top: 20px;
}

.login-title h2 {
  font-size: 22px;
  font-weight: normal;
}

.login-title p {
  font-size: 12px;
  margin-top: 40px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
}

.login-form {

  width: 600px;
  padding: 60px 100px;
  background: #fff;
}

.login-footer {
  text-align: center;
  color: #999;
  margin-top: 100px;
}

.login_box {
  position: absolute;
  top: 30px;
  /* left: 0px; */
  right: 180px;
  bottom: 0px;
  width: 420px;
  height: 380px;
  background: #fff;
  box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.3);
  border-radius: 20px
}

.login_top {
  position: relative;
  background-image: url('../../../static/loginPic.jpg');
  background-size: 100% 100%;
  height: 450px;
  margin-top: 20px;
}</style>



// WEBPACK FOOTER //
// src/views/myLogin/jumpLogin.vue